import { Typography } from 'gu-ui-kit'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { generatePath, useHistory } from 'react-router'
import { ROUTES } from 'constants/routes'
import { useParams } from 'react-router-dom'
import { ACTIVATE } from 'modules/Auth/types'
import { useDispatch, useSelector } from 'react-redux'

const Activation = () => {
  const { t } = useTranslation()
  const { token } = useParams()
  const { i18n } = useSelector(({ app }) => app)

  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!token?.length) {
      return
    }

    new Promise((resolve, reject) => {
      dispatch({
        meta: { resolve, reject },
        type: ACTIVATE,
        payload: {
          data: { token },
        },
      })
    }).catch(() => {
      history.push(generatePath(ROUTES.AUTH_LOGIN, { i18n }))
    })
  }, [token, dispatch])

  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::activation.title')}</title>
      </Helmet>

      <Typography
        className={'margin-bottom-40'}
        component={'h1'}
        variant={'Body-Accent-40'}
        color={'Label-Fifth'}
      >
        {t('auth::activation.title')}
      </Typography>
    </>
  )
}

export default Activation
